// Stable semantic identifiers shared by the production confirmation hosts and
// the screenshot/audit contracts. These describe real product decisions; they
// are not visual-test-only state toggles.
export const decisionConfirmVariants = {
  dashboardDeleteLeague: "dashboard-delete-league",
  draftAiFinish: "draft-ai-finish",
  draftSimToPick: "draft-sim-to-pick",
  negotiationEnd: "negotiation-end",
  negotiationResignAll: "negotiation-resign-all",
  protectIncomplete: "protect-incomplete",
  protectIncompleteMulti: "protect-incomplete-multi",
  rosterRelease: "roster-release",
} as const;
